import { api } from './client';
import { SyncPpcModelsResponse } from './types';

export const syncPpcModels = async (): Promise<SyncPpcModelsResponse> => {
  const { data } = await api.post<SyncPpcModelsResponse>('/admin/syncPpcModels');
  return data;
};
